const SEGMENT_METHODS = [
  'trackSubmit',
  'trackClick',
  'trackLink',
  'trackForm',
  'pageview',
  'identify',
  'reset',
  'group',
  'track',
  'ready',
  'alias',
  'debug',
  'page',
  'once',
  'off',
  'on',
  'addSourceMiddleware',
  'addIntegrationMiddleware',
  'setAnonymousId',
  'addDestinationMiddleware',
]

const shouldLoadSegment = () => {
  if (typeof navigator === 'undefined') return false
  return !navigator.userAgent.includes('DatadogSynthetics')
}

const getWriteKey = () =>
  (process.env.REACT_APP_SEGMENT_WRITE_KEY || '').trim()

export const loadSegment = () => {
  if (typeof window === 'undefined' || !shouldLoadSegment()) return

  const writeKey = getWriteKey()
  if (!writeKey) {
    // Avoid trying to initialize with an empty key.
    console.warn('Segment write key is missing; analytics is disabled.')
    return
  }

  const analytics = (window.analytics = window.analytics || [])

  if (analytics.initialize) return

  if (analytics.invoked) {
    if (window.console?.error) {
      window.console.error('Segment snippet included twice.')
    }
    return
  }

  analytics.invoked = true
  analytics.methods = SEGMENT_METHODS
  analytics.factory = (method) => {
    return (...args) => {
      analytics.push([method, ...args])
      return analytics
    }
  }

  analytics.methods.forEach((method) => {
    analytics[method] = analytics.factory(method)
  })

  analytics.load = (key, options) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)
    analytics._loadOptions = options
  }

  analytics._writeKey = writeKey
  analytics.SNIPPET_VERSION = '4.15.2'
  analytics.load(writeKey)
}
